import { Component, Input } from '@angular/core';
import {AuthenticationGuard} from '../services/authentication-guard.service';

@Component({
  selector: 'app-client-dossier-tabs',
  templateUrl: './client-dossier-tabs.component.html'
})

export class ClientDossierTabsComponent {
  @Input() selectedEntityId: String;
  @Input() selectedEntityType: String;

  constructor(
    private authenticationGuard: AuthenticationGuard,
  ) { }
  notDnb() {
    return !this.authenticationGuard.isDnbUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/client-dossier-tabs.component.ts